import { FC, useEffect, useRef } from "react"
import { Loader } from "@/shared/ui/loader"
import { NoTableData } from "@/shared/ui/no-table-data"
import { IBonusTransaction, IStore, ITransactionCheck } from "@/shared/api/bonuses"
import { BonusTransactionsTableRenderer } from "./bonus-transactions-table-renderer"

interface BonusTransactionsTableProps {
    stores: {[key: string]: IStore}
    checks: {[key: string]: ITransactionCheck}
    transactions: IBonusTransaction[]
    isLoading: boolean
    nextPage: () => void
}

export const BonusTransactionsTable: FC<BonusTransactionsTableProps> = ({ stores, checks, transactions, isLoading, nextPage }) => {
    const observerRef = useRef<HTMLDivElement>(null)
    
    const observerOptions: IntersectionObserverInit = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0
    }

    useEffect(() => {
        const handleObserve = (entries: IntersectionObserverEntry[]) => {
            const [ entry ] = entries
            if ( entry?.isIntersecting ) {
                nextPage()
            }
        }
        const observer = new IntersectionObserver(handleObserve, observerOptions)
        if (observerRef.current) observer.observe(observerRef.current)  
        return () => {
            if (observerRef.current) observer.unobserve(observerRef.current)  
        }
    }, [observerRef, observerOptions])

    return (
        <>
            {Boolean(transactions.length) &&
                <div className="table_box">
                    <BonusTransactionsTableRenderer 
                        transactions={transactions} 
                        stores={stores}
                        checks={checks}
                    />
                    <div ref={observerRef} id="observer"/>
                </div>
            }
            {(!Boolean(transactions.length) && isLoading) &&
                <div className="info_panel">
                    <Loader />
                </div>
            }
            {(!Boolean(transactions.length) && !isLoading) &&
                <NoTableData label="Нет данных о бонусных транзакциях"/>
            }
        </>
        
    )
}